import React from 'react';
import { OtTemplateQuery } from '../../../../../../../graphql-types';
import { usePageContext } from '../../../../../../hooks/contexts/usePageContext';
import { FaIcon } from '../faIcon/FaIcon';
import * as styles from './resume.module.scss';

interface IResumeProps {
  data?: NonNullable<NonNullable<OtTemplateQuery['ingenieOt']>['content']>['resume'];
}

export const Resume = ({ data }: IResumeProps) => {
  const { lang } = usePageContext();

  return (
    <ul className={styles.wrapper}>
      {data?.map((resume) => (
        <li key={resume?.id} className={styles.resumeWrapper}>
          <div className={styles.icon}>
            {resume?.valeur && <label>{resume?.valeur}</label>}
            {resume?.pictoUrl !== '' && (
              <img src={resume?.pictoUrl ?? ''} alt={resume?.label?.[lang]} loading="lazy" />
            )}
            {resume?.pictoUrl === '' &&
              resume?.picto !== '' &&
              resume?.picto
                ?.split(' + ')
                .map((picto) => <FaIcon key={`key-resume-picto-${picto}`} icon={picto ?? ''} />)}
          </div>
          <div>{resume?.label?.[lang]}</div>
        </li>
      ))}
    </ul>
  );
};
